<template>
    <div>
        <!--面包屑-->
        <breadcrumb-link :title="getTitle"></breadcrumb-link>
        <!--内容区域-->
        <div>
            <el-button type="info" size="small" plain @click="goBack" class="floatClass">返回</el-button>
            <el-form :model="dataList" ref="dataList" label-width="170px" :disabled="getDisabled" :rules="rules">
                <div class="edit-title">基础信息</div>
                <el-form-item label="物理数据库db名称:" prop="name">
                    <el-input v-model="dataList.name" placeholder="名称不能超过50个字符" style="width: 800px;" maxlength="50"></el-input>
                </el-form-item>
                <el-form-item label="物理数据库db类型: " prop="dbTypeId">
                    <el-select placeholder="请选择：" v-model="dataList.dbTypeId">
                        <el-option v-for="item in dbTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="请选择要绑定逻辑库db:" prop="logicalDbId">
                    <el-select placeholder="请选择" v-model="dataList.logicalDbId">
                        <el-option v-for="item in logicalList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="物理库表描述:" prop="description">
                    <el-input v-model="dataList.description" placeholder="描述不能为空" style="width: 800px;"></el-input>
                </el-form-item>
                <div class="info">
                    <div class="flexInline">
                        <el-form-item label="连接的数据库集群地址:" prop="clusterAddress">
                            <el-input v-model="dataList.clusterAddress" placeholder="请输入" style="width: 300px; margin-right: 30px;"></el-input>
                        </el-form-item>
                        <el-form-item label="destination: " prop="destination">
                            <el-input v-model="dataList.destination" placeholder="请输入" style="width: 300px;"></el-input>
                        </el-form-item>
                    </div>
                    <div class="flexInline">
                        <el-form-item label="user_name: " prop="userName">
                            <el-input v-model="dataList.userName" placeholder="请输入" style="width: 300px; margin-right: 30px;"></el-input>
                        </el-form-item>
                        <el-form-item label="user_password:" prop="userPswd">
                            <el-input v-model="dataList.userPswd" placeholder="请输入" style="width: 300px;"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="centerClass" v-if="!getDisabled">
                    <el-button type="primary" @click="submitForm('dataList')" v-if="type != 'details'">保存
                    </el-button>
                    <el-button type="info" plain @click="goBack">返回</el-button>
                </div>
                <!--schema配置-->
                <data-base-form-table :logicalDataBaseID="dataList.logicalDbId" v-if="$route.query.id&&dataList.logicalDbId"></data-base-form-table>
                <!--记录信息-->
                <history-record :historyTitle="historyTitle" :historyList="historyList" v-if="getDisabled" />
            </el-form>
        </div>
    </div>
</template>

<script>
import dataBaseFormTable from "./componet/dataBaseFormTable";
import BreadcrumbLink from "../../components/breadcrumbLink";
import util from "@/utils/util";
import HistoryRecord from "../../components/common/historyRecord";
import DialogTips from "../../components/dialogTips";
import { getDbDetail, addOrEditDb } from "@/apis/pipelineService/physicalDb";
import { mapState, mapActions } from "vuex";
export default {
    components: {
        DialogTips,
        HistoryRecord,
        BreadcrumbLink,
        dataBaseFormTable
    },
    data() {
        return {
            // dbTypeList: [], // 数据库类型
            type: "", // 跳转页面获取标题
            dataList: {
                name: "", // 物理库名称
                dbTypeId: "", // 数据库db类型
                logicalDbId: "", // 逻辑库db
                userName: "",
                userPswd: "",
                clusterAddress: "", // 连接的数据地址
                destination: "",
                description: "" // 描述
            },
            historyTitle: "记录信息", // 记录信息标题
            historyList: [
                {
                    label: "创建人：",
                    value: ""
                },
                {
                    label: "创建时间：",
                    value: ""
                },
                {
                    label: "最后修改人：",
                    value: ""
                },
                {
                    label: "最后修改时间：",
                    value: ""
                }
            ], // 记录信息信息内容
            id: this.$route.query.id,
            rules: {
                name: [
                    {
                        required: true,
                        message: "请输入逻辑库db名称",
                        trigger: "blur"
                    },
                    {
                        min: 1,
                        max: 50,
                        message: "名称不能超过50个字符",
                        trigger: "blur"
                    }
                ],
                dbTypeId: [
                    {
                        required: true,
                        message: "请选择物理数据库db类型",
                        trigger: "change"
                    }
                ],
                logicalDbId: [
                    {
                        required: true,
                        message: "请选择要绑定逻辑库db",
                        trigger: "change"
                    }
                ],
                clusterAddress: [
                    {
                        required: true,
                        message: "请输入连接的数据库集群地址",
                        trigger: "blur"
                    }
                ],
                destination: [
                    {
                        required: true,
                        message: "请填写destination",
                        trigger: "blur"
                    }
                ],
                userName: [
                    {
                        required: true,
                        message: "请填写user_name",
                        trigger: "blur"
                    }
                ],
                userPswd: [
                    {
                        required: true,
                        message: "请填写user_password",
                        trigger: "blur"
                    }
                ],
                description: [
                    { required: true, message: "请填写描述", trigger: "blur" }
                ]
            },
            id: ""
        };
    },
    computed: {
        getDisabled() {
            return {
                add: false,
                edit: false,
                details: true
            }[this.type];
        },
        getTitle() {
            return {
                add: "新增物理数据库",
                edit: "修改物理数据库",
                details: "物理数据库详情"
            }[this.type];
        },
        ...mapState({
            dbTypeList: state => state.dbTypeList,
            logicalList: state => state.logicalList
        })
    },
    mounted() {
        this.type = this.$route.query.type;
        this.id = this.$route.query.id;
        if (this.type != "add") {
            this.getDetails();
        }
        this.getDbTypeList();
        this.getLogicalListFu({ size: 10000, current: 1 });
    },
    methods: {
        ...mapActions([
            "getDbTypeList", // 获取数据库db类型
            "getLogicalListFu" // 获取逻辑库列表
        ]),
        // 返回上一层
        goBack() {
            this.$router.push({
                path: "/databaseManagement"
            });
        },
        //列表时间格式化
        dateFormat(timestamp) {
            if (timestamp) {
                return util.timestampToTime13(timestamp);
            }
            return "--";
        },
        // 详情
        async getDetails() {
            let params = {
                id: this.id
            };
            try {
                const data = await getDbDetail(params);
                if (data.code == 0 && data.data) {
                    this.dataList = data.data;
                    this.historyList = [
                        {
                            label: "创建人：",
                            value: data.data.creatorName
                        },
                        {
                            label: "创建时间：",
                            value: this.dateFormat(data.data.createTime)
                        },
                        {
                            label: "最后修改人：",
                            value: data.data.updatorName
                        },
                        {
                            label: "最后修改时间：",
                            value: this.dateFormat(data.data.updateTime)
                        }
                    ];
                } else {
                    this.$message.error(data.message);
                }
            } catch (error) {}
        },
        // 提交表单
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.pushForm();
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        // 提交
        async pushForm() {
            let params = {
                id: this.id,
                name: this.dataList.name, // 物理库名称
                dbTypeId: this.dataList.dbTypeId, // 数据库db类型
                logicalDbId: this.dataList.logicalDbId, // 逻辑库db
                userName: this.dataList.userName,
                userPswd: this.dataList.userPswd,
                clusterAddress: this.dataList.clusterAddress, // 连接的数据地址
                destination: this.dataList.destination,
                description: this.dataList.description
            };
            if (this.type == "add") {
                delete params.id;
            }
            try {
                const data = await addOrEditDb(params);
                if (data.code == 0) {
                    this.$router.push({
                        path: "/databaseManagementForm",
                        query: {
                            type: "edit",
                            id: data.data.id || this.$route.query.id
                        }
                    });
                    this.type = "edit";
                    this.$message.success("成功");
                } else {
                    this.$message.error(data.message);
                }
            } catch (error) {}
        }
    }
};
</script>

<style scoped lang="scss">
.flexInline {
    display: flex;
}
.info {
    width: 100%;
    margin: 0 auto;
    background: #f8f8f8;
    border-radius: 10px;
    padding: 20px;
    margin-bottom: 20px;
}
.centerClass {
    text-align: center;
    margin: 0 auto;
    margin-top: 20px;
    .el-button {
        margin: 0 20px;
    }
}
.floatClass {
    float: right;
}
</style>
